"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));
/* eslint-disable */


var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "38",
    height: "38",
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    style: {
      mixBlendMode: 'luminosity'
    }
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38Z",
    fill: "#FFDE63"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0417 15.0416C34.0417 25.5351 25.5351 34.0416 15.0417 34.0416C10.8047 34.0416 6.89154 32.6547 3.73157 30.3101C7.19359 34.9761 12.7437 38 19 38C29.4935 38 38 29.4934 38 19C38 12.7436 34.9762 7.19352 30.3102 3.73151C32.6548 6.89148 34.0417 10.8046 34.0417 15.0416Z",
    fill: "#FFD13E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.4896 20.9792C13.6595 20.9792 16.2292 18.4095 16.2292 15.2396C16.2292 12.0697 13.6595 9.5 10.4896 9.5C7.3197 9.5 4.75 12.0697 4.75 15.2396C4.75 18.4095 7.3197 20.9792 10.4896 20.9792Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.5105 20.9792C30.6803 20.9792 33.25 18.4095 33.25 15.2396C33.25 12.0697 30.6803 9.5 27.5105 9.5C24.3406 9.5 21.7709 12.0697 21.7709 15.2396C21.7709 18.4095 24.3406 20.9792 27.5105 20.9792Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.4791 18.2083C12.4629 18.2083 13.2604 17.4108 13.2604 16.4271C13.2604 15.4433 12.4629 14.6458 11.4791 14.6458C10.4954 14.6458 9.69788 15.4433 9.69788 16.4271C9.69788 17.4108 10.4954 18.2083 11.4791 18.2083Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.5 18.2083C29.4838 18.2083 30.2812 17.4108 30.2812 16.4271C30.2812 15.4433 29.4838 14.6458 28.5 14.6458C27.5162 14.6458 26.7188 15.4433 26.7188 16.4271C26.7188 17.4108 27.5162 18.2083 28.5 18.2083Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.7292 26.125H12.2709V28.5H25.7292V26.125Z",
    fill: "black"
  })));
};

exports.default = _default;